import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProvider } from "./context/AppContext";
import { AuthProvider } from "./context/AuthContext";
import "./styles/globals.css";

import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";

import Home          from "./pages/Home/Home";
import CategoryPage  from "./pages/CategoryPage/CategoryPage";
import CoursePage    from "./pages/CoursePage/CoursePage";
import CheckoutPage  from "./pages/Checkout/Checkout";
import AdminPage     from "./pages/Admin/Admin";
import LoginPage     from "./pages/Login/Login";
import MyCoursesPage from "./pages/MyCourses/MyCourses";
import {
  AboutPage, ContactPage, RefundPage, PrivacyPage, TermsPage,
} from "./pages/Static/Static";

function Layout({ children, hideFooter }) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      {!hideFooter && <Footer />}
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/"               element={<Layout><Home /></Layout>} />
            <Route path="/category/:id"   element={<Layout><CategoryPage /></Layout>} />
            <Route path="/course/:id"     element={<Layout><CoursePage /></Layout>} />
            <Route path="/checkout"       element={<Layout><CheckoutPage /></Layout>} />
            <Route path="/login"          element={<Layout><LoginPage /></Layout>} />
            <Route path="/my-courses"     element={<Layout><MyCoursesPage /></Layout>} />
            <Route path="/about"          element={<Layout><AboutPage /></Layout>} />
            <Route path="/contact"        element={<Layout><ContactPage /></Layout>} />
            <Route path="/refund-policy"  element={<Layout><RefundPage /></Layout>} />
            <Route path="/privacy-policy" element={<Layout><PrivacyPage /></Layout>} />
            <Route path="/terms"          element={<Layout><TermsPage /></Layout>} />
            <Route path="/superadmin"     element={<Layout hideFooter><AdminPage /></Layout>} />
          </Routes>
        </BrowserRouter>
      </AppProvider>
    </AuthProvider>
  );
}
